//@vendors
import { useContext, useEffect, useState } from 'react'
import Context from 'context/appContext';
import moment from 'moment';
import { fields } from 'constants/fieldTypes';
import { filterObject, validateForm, InsuredKeys, getSidebarData, getBody, getNewObject } from 'utils/utils';

//@components
import { Button, Form, Modal } from 'antd'

//@styles
import './styles.scss'
import ModalConfirm from 'components/modal-confirm';

export default function InsuredInfo({ info, current, form }) {
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [modalData, setModalData] = useState({});

    const { customRequest, dataForm: { data: dataF, formResponses, disabledFields, hiddenFields },
        insureds, setInsureds, setSidebarData, isActive, setIsActive,
        setPriceToShow, setPolicyNumber, tokenInfo, isClassActive, validateRFC } = useContext(Context);

    useEffect(() => { getInsureds() }, []);

    useEffect(() => {
        insureds && insureds.length <= 1 && data && data.length > 0 && onClickSave(data[0].key)
    }, [isActive])

    const getInsureds = () => {
        let copyInsureds = [...insureds];
        if (!copyInsureds || copyInsureds.length === 0) {
            const genderField = formResponses && formResponses.find(t => t.key === 'genero');
            const newGenderKey = genderField && genderField.value ? genderField.value : 'H';
            const image = genderField.properties && genderField.properties[newGenderKey];
            const date = formResponses && formResponses.find(z => z.key === "fechaNacimiento");
            const infoLabel = genderField?.values.find((e)=>e.value===newGenderKey);

            copyInsureds = [{
                key: moment().unix(),
                type: "T",
                img: image,
                gender: newGenderKey,
                age: date.value,
                label : infoLabel?.label
            }];
        }
        setData(copyInsureds);
    }

    const onClickEdit = (index) => {
        setIsActive({ ...isActive, [index]: false });
    }

    const setValue = (value) => {
        const fieldNameKey = 'nombre';
        const fieldNameIndex = formResponses && formResponses.findIndex(fr => fr.key === fieldNameKey);
        if (fieldNameIndex && fieldNameIndex !== -1) {
            formResponses[fieldNameIndex].value = value;
            form.setFieldsValue({ [fieldNameKey]: value });
        }
    }

    const onClickSave = async (index) => {
        const fieldsValues = filterObject(form.getFieldsValue(), index);
        const fieldsKeys = Object.keys(fieldsValues);
        if (await validateForm(fieldsKeys, form)) {
            const insuredIndex = data && data.findIndex(d => d.key === index);
            const type = data[insuredIndex].type === "T" ? "Titular" : "Adicional";
            if (insureds.length > 0 ? await validateRFC(getNewObject(fieldsValues, type, index)) : true) {
                if (type === 'Titular' && tokenInfo && tokenInfo.usuarioId) {
                    const indexEmail = formResponses && formResponses.findIndex(fe => fe.key === 'email');
                    const valueEmail = fieldsValues[`email${type}-${index}`];
                    formResponses[indexEmail].value = valueEmail
                    form.setFieldsValue({ 'email': valueEmail });
                }
                data[insuredIndex] = {
                    ...data[insuredIndex],
                    name: fieldsValues[`primerNombre${type}-${index}`],
                    surname: fieldsValues[`primerApellido${type}-${index}`],
                    secondSurname: fieldsValues[`segundoApellido${type}-${index}`],
                    rfc: fieldsValues[`identificadorPersona${type}-${index}`]
                }
                insureds[insuredIndex] = data[insuredIndex];
                setSidebarData(getSidebarData(insureds, formResponses));
                type === "Titular" && setValue(fieldsValues[`primerNombre${type}-${index}`]);
                setIsActive({ ...isActive, [index]: insureds.length > 1 });
                setInsureds([...insureds]);

            }
        }
    }

    const deleteInsured = async (index) => {
        const newArrayInsureds = insureds.filter(x => x.key !== index);
        const newData = data.filter(x => x.key !== index);
        setInsureds(newArrayInsureds);
        setData(newData);
        requote(newArrayInsureds);
    }

    const requote = async (valInsureds) => {
        const optionsRequest = dataF && dataF.infoRequote && dataF.infoRequote.infoRequest;
        const body = getBody({}, dataF.modelConfig, formResponses, valInsureds, tokenInfo, isClassActive);
        const res = await customRequest(optionsRequest.url, optionsRequest.headers, optionsRequest.method, body);
        if (res && res.success && res.respuesta.policy) {
            const policy = res.respuesta.policy;
            setPolicyNumber(policy.policy.policyNumber);
            setPriceToShow(policy.costs.amount);
            setModel(policy.policy);
            dataF['infoRequote'] = { res, infoRequest: optionsRequest };
            setSidebarData(getSidebarData(valInsureds, formResponses));
        }
        setModalData({ visible: false })
    }

    const setModel = (policy) => {
        if (policy && Object.keys(policy).length > 0) {
            dataF.modelConfig['polizaCotizacion'] = {
                "oficina": policy.officeId,
                "ramo": policy.productId,
                "estado": "W",
                "poliza": policy.policyNumber,
                "suplemento": 0,
                "rfc": "XXXXXXX"
            };
        }
    }

    const onClickDelete = (index) => {
        const infoD = {
            index: index,
            title: "Confirmación",
            description: '¿Eliminas a este asegurado de la póliza?',
            visible: true
        }
        setModalData(infoD, deleteInsured);
    }

    const setDisabledField = (fieldKey, newKeyField) => {
        switch (fieldKey) {
            case 'emailTitular':
                disabledFields[newKeyField] = !(tokenInfo && tokenInfo.usuarioId);
                break;
            case 'sexoTitular':
                disabledFields[newKeyField] = true;
                break;
            default:
                break;
        }
    }

    const getConfigField = (field, newKeyField, insured) => {
        let copyField = {};
        const indexfieldPersistence = formResponses &&
            formResponses.findIndex(fp => fp.key === newKeyField);
        setDisabledField(field.key, newKeyField);
        if (indexfieldPersistence && indexfieldPersistence === -1) {
            copyField = JSON.parse(JSON.stringify(field));
            copyField.key = newKeyField;
            if (copyField && insured.type !== "T") {
                copyField.value = field.key === "sexoAdicional" ? insured.gender :
                    field.key === "fechaNacimientoAdicional" ?
                        moment(insured.age, ["DD/MM/YYYY", "YYYY-MM-DD"]).format('MM/DD/YYYY') : '';
                disabledFields[newKeyField] = (field.key === "sexoAdicional" || field.key === "fechaNacimientoAdicional");
            }
        } else {
            copyField = formResponses[indexfieldPersistence];
        }

        return copyField
    }

    const getOptions = (field, allFieldsValues) => {
        const rfcKey = Object.keys(allFieldsValues).find(key => key.includes("identificadorPersona"));
        const rfcValue = allFieldsValues[rfcKey];
        const logic = field && field.logic[0];
        const options = logic.trigger && logic.trigger.json;
        options.url = options.url.replace("value", rfcValue && rfcValue.toUpperCase());
        return options;
    }

    const infoSearch = async (item, field) => {
        setIsLoading(true);
        const allFieldsValues = filterObject(form.getFieldsValue(), item.key);
        const options = getOptions(field, allFieldsValues);
        const response = await customRequest(options.url, options.headers, options.method, options.body);

        if (response && response.identificador) {
            const allKeys = Object.keys(allFieldsValues);
            const responseKeys = Object.keys(response).filter(resKey => resKey === "primerNombre" ||
                resKey === "primerApellido" || resKey === "segundoApellido");
            item && item.type === 'T' && setInternalIdentifier(response);
            responseKeys && responseKeys.forEach(resKeyVal => {
                const fieldFormKey = allKeys && allKeys.find(akey => akey.includes(resKeyVal));
                const fieldIndex = formResponses && formResponses.findIndex(fr => fr.key === fieldFormKey);
                const newValue = resKeyVal === 'primerNombre' ? `${response[resKeyVal]} ${response['segundoNombre'] || ''}` : response[resKeyVal];
                formResponses[fieldIndex].value = newValue;
                form.setFieldsValue({ [fieldFormKey]: newValue });
            });
        } else {
            showModal({ title: "Ops!", body: 'No hemos encontrado los datos en nuestro sistema. Por favor completa el formulario' });
        }
        setIsLoading(false);
    }

    const setInternalIdentifier = (dataI) => {
        const fValue = dataI && dataI.numeroInterno;
        const nField = { key: 'internalIdentifierContratante', value: fValue };
        const index = formResponses.findIndex(x => x.key === 'internalIdentifierContratante');
        index != -1 ? formResponses[index].value = fValue : formResponses.push(nField);
    }

    const showModal = (message) => {
        Modal.info({
            icon: '',
            title: message.title,
            className: 'modal-confirm',
            closable: true,
            okButtonProps: {
                className: 'ant-btn-solid c-2 ant-btn-size-xs'
            },
            okText: 'Confirmar',
            content: <p>{message.body}</p>,
            onOk() { }
        });
    }

    const fieldSearch = (field, key, item) => {
        return (
            <Form.Item
                name={key}
                key={key}
                hidden={hiddenFields[key]}
            >
                <Button
                    className='ant-btn-outline c-2 ant-btn-size-xs'
                    onClick={() => infoSearch(item, field)}
                    loading={isLoading}
                >
                    <strong>{field.label}</strong>
                </Button>
            </Form.Item>
        )
    }

    const showIsured = (item, index) => {
        return item && Object.keys(item).length && (
            <div className={`insured-info-item insured-info-item-min show`} id={index}>
                <img src={item.img} className="insured-info-item-min-img" alt={item?.label} />
                <div className="insured-info-item-min-body">
                    <div className="insured-info-item-min-body-title">
                        <p>Asegurado</p>
                        <p>{InsuredKeys[2][item.type]}</p>
                    </div>
                    <div className="insured-info-item-min-body-name">
                        {`${item.name} ${item.surname} ${item.secondSurname} | ${item.rfc}`}
                    </div>
                </div>
                <div className="insured-info-item-min-action">
                    <em className="fal fa-pencil-alt" onClick={() => onClickEdit(index)} />
                    {item.type !== "T" && (<em className="fal fa-trash-alt" onClick={() => onClickDelete(index)} />)}
                </div>
            </div>
        )
    }

    const showFields = (panel, item) => {
        const components = panel && panel.components;
        return item && (
            <div className={`insured-info-item insured-info-item-max show`} id={item.key}>
                <div className="insured-info-item insured-info-item-max-id">
                    <img src={item.img} className="insured-info-item-max-id-img" alt={item?.label}/>
                    <div className="insured-info-item-max-id-body">
                        <div className="insured-info-item-max-id-body-title">
                            <p>Asegurado</p>
                            <p>{InsuredKeys[2][item.type]}</p>
                        </div>
                    </div>
                </div>
                {components && components.length && components.map((field) => {
                    const newKey = `${field.key}-${item.key}`;
                    const fieldType = field.customClass ? field.customClass : field.type;
                    return fieldType === "button" ? fieldSearch(field, newKey, item) :
                        fields(fieldType, getConfigField(field, newKey, item), form, newKey, current);
                })}
                <div className="insured-info-item insured-info-item-max-btn">
                    {item.type !== "T" && (<Button
                        className='ant-btn-text c-2 ant-btn-size-xs'
                        onClick={() => onClickDelete(item.key)}
                        data-testid={item.key}
                    >
                        <strong>Eliminar</strong>
                    </Button>)}
                    {insureds && insureds.length > 1 && (<Button
                        className='ant-btn-outline c-2 ant-btn-size-xs'
                        onClick={() => onClickSave(item.key)}
                    >
                        <strong>Guardar</strong>
                    </Button>)}
                </div>
            </div>
        )
    }

    return (
        <>
            {modalData.visible && (<ModalConfirm info={modalData} handleClick={deleteInsured} />)}
            <div className="insured-info">
                {data && data.length && data.map(item =>
                    (isActive[item && item.key] && insureds.length > 1) ? showIsured(item, item.key) :
                        showFields(info && info.components.find(x => x.key === InsuredKeys[4][item && item.type]), item)
                )}
            </div>
        </>
    )
}